import { create } from "zustand";

export const useCampaignPage = create((set) => ({
  showPageLoader: false,
  setShowPageLoader: (showPageLoader) => set({ showPageLoader }),
}));
